const type = 'TOGGLE_PROGRAM_SELECTOR';

const toggleProgramSelector = () => ({
  type,
});

export { type };
export default toggleProgramSelector;
